import React, { useContext, useEffect, useRef, useState } from 'react';
import { MenuList } from '@/components/menuList';
import { Text, Flex, Icon, Menu, MenuButton, MenuItem, IconButton, useDisclosure, Box, Button, Tooltip } from '@chakra-ui/react';
import { MdArrowForward, MdDevices, MdDragIndicator, MdFace, MdMoreVert, MdOutlineEdit, MdOutlineLayers, MdOutlineLayersClear, MdArrowOutward, MdSync, MdOutlineWarning } from 'react-icons/md';
import InsightTags from '@/insight/components/insightTags';
import { ProductPageContext } from '../lib/productPageContext';
import useExperienceApi from '@/experiences/lib/useExperienceApi';
import { ProductContext } from '../../lib/productContext';
import ExperienceGroupInProductNameForm from './experienceGroupInProductNameForm';
import MoveGroupInProductToGroupForm from './moveGroupInProductToGroupForm';
import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from '@chakra-ui/modal';
import usePersonaApi from '@/persona/lib/usePersonaApi';
import useProductsApi from '../../lib/useProductsApi';
import ProductProvider from '../../lib/productProvider';
import PersonaProvider from '@/persona/lib/personaProvider';
import PersonaThumbnail from '@/persona/components/personaThumbnail';
import ProductLogo from '../../components/productLogo';
import { useNavigate } from 'react-router-dom';
import SharedExperienceTag from '@/components/sharedExperienceTag';
import useTranslation from '../../../lib/i18n/useTranslation';

export default function ExperienceGroupInProductListItem(props) {
  const { t } = useTranslation();
  const {
    refreshExperienceList,
    refreshPersonaList,
    refreshSharedExperienceList,
    parentGroup,
    experienceGroupList,
  } = useContext(ProductPageContext);
  const {
    productId,
    rights,
  } = useContext(ProductContext);
  const {
    experienceGroup,
    dragHover = false
  } = props;
  const experienceApi = useExperienceApi();
  const navigate = useNavigate();
  const [personaList, setPersonaList] = useState(false);
  const [productList, setProductList] = useState(false);
  const personaApi = usePersonaApi();
  const productApi = useProductsApi();
  const [isAdding, setIsAdding] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const modalEditGroupName = useDisclosure();
  const modalMoveToGroup = useDisclosure();
  const modalConvertToSharedExperience = useDisclosure();
  const [isConverting, setIsConverting] = useState(false);
  const ref1 = useRef();
  const ref2 = useRef();
  
  const ungroup = async () => {
    try {
      await experienceApi.ungroupExperienceGroupInProduct(experienceGroup.id)
      await Promise.all([
        refreshExperienceList(),
        refreshPersonaList()
      ])
    } catch (error) {
      console.error(error);
    }
  }
  
  const convertToSharedExperience = async () => {
    try {
      setIsConverting(true);
      await experienceApi.convertProductGroupToSharedExperience(productId, experienceGroup.id);
      modalConvertToSharedExperience.onClose();
      await Promise.all([
        refreshExperienceList(),
        refreshPersonaList(),
        refreshSharedExperienceList()
      ]);
    } catch (error) {
      console.error(error);
    } finally {
      setIsConverting(false);
    }
  }
  
  useEffect(() => {
    if (experienceGroup) {
      const personas = experienceGroup.personas ? 
        (Array.isArray(experienceGroup.personas) ? experienceGroup.personas : [experienceGroup.personas]) : 
        [];
      const products = experienceGroup.products ? 
        (Array.isArray(experienceGroup.products) ? experienceGroup.products : [experienceGroup.products]) : 
        [];
      setPersonaList(personas);
      setProductList(products);
    }
  }, [experienceGroup]);
  
  if (!experienceGroup || (!experienceGroup.group?.name && !experienceGroup.name)) {
    return null;
  }

  return (
    <>
      <Flex
        px={3}
        py={2}
        backgroundColor={dragHover ? "background.purple" : "white"}
        role={'group'}
        _hover={{
          background: "background.grey",
        }}
        height={"90px"}
        position={"relative"}
        justifyContent={"space-between"}
      >
        {rights.can_update && (
          <Flex
            position={"absolute"}
            top="0"
            left={"0"}
            height={"100%"}
            opacity={0}
            _groupHover={{ opacity: '1' }}
            cursor={"grab"}
            py={2}
            pr={3}
          >
            <Icon
              as={MdDragIndicator}
              boxSize={'20px'}
              color={"text.light.grey"}
              mr={2}
            />
          </Flex>
        )}
        <Flex
          flexDirection={"column"}
          flex={1}
        >
          <Flex
            flex={1}
            alignItems={"flex-start"}
          >
            <Flex
              alignItems={"flex-start"}
            mb={1}
              flex={1}
          >
            <Icon
              as={MdOutlineLayers}
              boxSize={'15px'}
              mr={2}
                mt={"3px"}
              color="text.medium.purple"
            />
              <Flex flexDirection={"column"}>
            <Text
              noOfLines={2}
              color="text.medium.purple"
                  fontWeight={"500"}
                >{experienceGroup.group?.name || experienceGroup.name}</Text>
                <Flex alignItems="center" gap={2} mt={1}>
            {experienceGroup?.shared_experiences?.name && (
              <SharedExperienceTag 
                sharedExperienceName={experienceGroup?.shared_experiences.name} 
                size="sm"
              />
            )}
            <Text
              fontSize={"12px"}
              color="text.medium.grey"
            >{experienceGroup.experience_count} Experience{(experienceGroup.experience_count > 0 ? 's' : '')}</Text>
          </Flex>
        </Flex>
            </Flex>
            <Flex
              flexDirection={"column"}
              alignSelf={"stretch"}
              height={"100%"}
              alignItems={"flex-end"}
            >
              <Flex flex={1} alignItems={"flex-start"}>
            <InsightTags
              nbPostiveFeedback={experienceGroup.insights_count?.positive_count || 0}
              nbNegativeFeedback={experienceGroup.insights_count?.negative_count || 0}
              nbImprovementFeedback={experienceGroup.insights_count?.improvement_count || 0}
              nbBehavior={experienceGroup.insights_count?.behavior_count || 0}
              nbMotivation={experienceGroup.insights_count?.motivation_count || 0}
            />
              </Flex>
              <Flex>
              {(personaList && personaList.length > 0) && (
                <Flex
                  alignItems={"center"}
                  mr={3}
                >
                  <Icon
                    as={MdFace}
                    size="20"
                    color="text.medium.grey"
                  />
                  {personaList.map((p, i) => (
                    <Tooltip
                      label={p.name}
                      key={i}
                    >
                      <Flex
                        ml={2}
                      >
                        <PersonaProvider
                          personaId={p.id}
                          originalPersona={p}
                          needRights={false}
                          needRole={false}
                          needEditionRequest={false}
                        >
                          <PersonaThumbnail
                            size={20}
                            hasAcronym={true}
                          />
                        </PersonaProvider>
                      </Flex>
                    </Tooltip>
                  ))}
                </Flex>
              )}
              {(productList && productList.length > 0) && (
                <Flex alignItems={"center"}>
                  <Icon
                    as={MdDevices}
                    size="20"
                    color="text.medium.grey"
                  />
                    {productList.map((p, i) => (
                    <Tooltip
                      label={p.name}
                      key={i}
                    >
                      <Flex
                        ml={2}
                      >
                        <ProductProvider
                          productId={p.id}
                          orignalProduct={p}
                          needRights={false}
                          needRole={false}
                          needEditionRequest={false}
                        >
                          <ProductLogo
                            size={20}
                            hasAcronym={true}
                          />
                        </ProductProvider>
                      </Flex>
                    </Tooltip>
                  ))}
                </Flex>
              )}
            </Flex>
          </Flex>
          </Flex>
        </Flex>
        <Flex>
          <Flex
            flex={1}
            alignItems={"center"}
          >
          </Flex>
          <Flex>
          <Flex
            height={"100%"}
            pl={3}
            alignItems={"center"}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
              <Menu>
                {({ isOpen }) => (
                  <>
                    <MenuButton
                      isActive={isOpen}
                      as={IconButton}
                      icon={<MdMoreVert />}
                      fontSize={"18px"}
                      size="md"
                      variant='greyTransparent'
                    />
                  <MenuList fontSize={"14px"}>
                    <MenuItem onClick={() => {
                      navigate(`/products/${productId}?group-id=${experienceGroup.id}`);
                    }} icon={<MdArrowForward />}>
                      Open group
                          </MenuItem>
                    {rights?.can_update && (
                      <>
                        {!experienceGroup.shared_experiences_id && (
                          <MenuItem onClick={modalEditGroupName.onOpen} icon={<MdOutlineEdit />}>
                            {t('group.editGroupName')}
                          </MenuItem>
                        )}
                        {!experienceGroup.shared_experiences_id && (
                          <MenuItem
                            onClick={modalMoveToGroup.onOpen}
                          >
                            <Icon as={MdArrowOutward} mr={2} color="text.medium.dark" />
                            <Text color="text.medium.dark">{t('group.moveToGroup')}</Text>
                          </MenuItem>
                        )}
                        {!experienceGroup.shared_experiences_id && (
                          <MenuItem onClick={ungroup} icon={<MdOutlineLayersClear />}>
                            {t('group.ungroup')}
                          </MenuItem>
                        )}
                        {!experienceGroup.shared_experiences_id && (
                          <MenuItem onClick={modalConvertToSharedExperience.onOpen} icon={<MdSync />}>
                            {t('group.convertToSharedExperience')}
                          </MenuItem>
                        )}
                      </>
                        )}
                      </MenuList>
                  </>
                )}
              </Menu>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
      <Modal isOpen={modalEditGroupName.isOpen} onClose={modalEditGroupName.onClose}>
          <ModalOverlay />
        <ModalContent>
          <ModalHeader>{t('group.editGroupName')}</ModalHeader>
          <ModalBody>
              <Box p={3}>
                <ExperienceGroupInProductNameForm
                group={{ name: experienceGroup.group?.name || experienceGroup.name }}
                  onSubmitting={() => {
                    setIsAdding(true);
                  }}
                onSubmitted={async () => {
                    setIsAdding(false);
                  modalEditGroupName.onClose();
                  await refreshExperienceList();
                  }}
                onValidityChange={setIsValid}
                groupId={experienceGroup.id}
                  ref={ref1}
                hideSave={true}
                />
              </Box>
            </ModalBody>
            <ModalFooter>
              <Button
                variant='purpleOutline'
                onClick={modalEditGroupName.onClose}
            >{t('common.cancel')}</Button>
              <Button
                variant="purpleFill"
                ml={2}
                isLoading={isAdding}
                isDisabled={!isValid}
                onClick={() => {
                  ref1.current.click();
                }}>{t('common.save')}</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      <Modal isOpen={modalMoveToGroup.isOpen} onClose={modalMoveToGroup.onClose}>
          <ModalOverlay />
        <ModalContent>
          <ModalHeader>{t('group.moveToGroup')}</ModalHeader>
          <ModalBody>
              <Box p={3}>
                <MoveGroupInProductToGroupForm
                experienceGroupList={experienceGroupList}
                  onSubmitting={() => {
                    setIsAdding(true);
                  }}
                onSubmitted={async () => {
                    setIsAdding(false);
                  modalMoveToGroup.onClose();
                  await refreshExperienceList();
                  }}
                onValidityChange={setIsValid}
                groupId={experienceGroup.id}
                  ref={ref2}
                hideSave={true}
                />
              </Box>
            </ModalBody>
            <ModalFooter>
              <Button
              variant='purpleOutline'
                onClick={modalMoveToGroup.onClose}
            >{t('common.cancel')}</Button>
              <Button
              variant="purpleFill"
                ml={2}
                isLoading={isAdding}
                isDisabled={!isValid}
                onClick={() => {
                  ref2.current.click();
                }}>{t('common.save')}</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      <Modal isOpen={modalConvertToSharedExperience.isOpen} onClose={modalConvertToSharedExperience.onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{t('group.convertToSharedExperience')}</ModalHeader>
          <ModalBody p={3}>
            <Flex
              border="1px"
              borderColor="divider.grey"
              borderRadius="2px"
              backgroundColor="white"
              alignItems={'center'}
              p={3}
            >
              <Icon
                as={MdOutlineWarning}
                color={'text.medium.yellow'}
                boxSize={'18px'}
                mr={3}
              />
              <Text textStyle="body" color={'text.dark.grey'}>
                Are you sure you want to convert the group "{experienceGroup.group?.name || experienceGroup.name}" into a shared experience? This action cannot be undone.
              </Text>
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button
              variant='purpleOutline'
              onClick={modalConvertToSharedExperience.onClose}
            >{t('common.cancel')}</Button>
            <Button
              variant="yellowFill"
              ml={2}
              isLoading={isConverting}
              onClick={convertToSharedExperience}
            >{t('common.convert')}</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
